import React, {useState, memo, useContext, useCallback, useEffect} from "react";
import CountryConfigContext from "../CountryConfigContext";
import useFetchFixedProducts from "../ui-components/pages/Users/hooks/useFetchFixedProducts";
import Select from "../ui-components/Select";
import checkIfStepIsVisible from "../utils/checkIfStepIsVisible";
import getAllConfiguratorOutputs from "../utils/getAllConfiguratorOutputs";
import prepareConfigurationStep from "../utils/prepareConfigurationStep";
import ConfiguratorContext from "./ConfiguratorContext";
import ConfiguratorSurvey from "./ConfiguratorSurvey";
import FixedLoader from "./FixedLoader";
import useFetchFixedSystems from "../ui-components/pages/Users/hooks/useFetchFixedSystems";
import useCountryAxiosInstance from "../hooks/useCountryAxiosInstance";
import convertSurveyResponses from "../utils/convertSurveyResponses";
import {prepareCrossData} from "../utils/prepareCrossData";

const ServiceConfiguratorPreview = ({
  returnPath,
  configuration,
  roleTypes,
  service,
  crossServiceConfigurations,
}) => {
  const {
    config: { products, systems },
  } = useContext(CountryConfigContext);

  const countryApiRequest = useCountryAxiosInstance();

  const [colors, setColors] = useState(null);
  const [kccOptimizationResults, setKccOptimizationResults] = useState({});
  const [connectionResults, setConnectionResults] = useState(null);
  const [spreadsheetResults, setSpreadsheetResults] = useState({});
  const [isCalculatingSpreadsheetsResults, setIsCalculatingSpreadsheetsResults] = useState(false);
  const [kColorResults, setKColorResults] = useState({});
  const [isCalculatingKColorResults, setIsCalculatingKColorResults] = useState(false);
  const [selectedRoleType, setSelectedRoleType] = useState(roleTypes[0].name);
  const [responses, setResponses] = useState({});
  const data = prepareConfigurationStep(configuration, selectedRoleType, service.id);
  const crossData = prepareCrossData(crossServiceConfigurations);
  const [kColorPricesChosen, setKColorPricesChosen] = useState({});

  const fetchFixedProducts = useFetchFixedProducts(data);
  const fetchFixedSystems = useFetchFixedSystems(data);
  const context = {
    configuration,
    data,
    responses,
    setResponses,
    products,
    systems,
    outputs: getAllConfiguratorOutputs(data),
    rolePreview: selectedRoleType,
    colors,
    kccOptimizationResults,
    setKccOptimizationResults,
    connectionResults,
    setConnectionResults,
    spreadsheetResults,
    setSpreadsheetResults,
    isCalculatingSpreadsheetsResults,
    setIsCalculatingSpreadsheetsResults,
    kColorResults,
    setKColorResults,
    isCalculatingKColorResults,
    setIsCalculatingKColorResults,
    service,
    context: "WEB",
    crossData,
    kColorPricesChosen,
    setKColorPricesChosen,
  };

  const getVisibleSteps = useCallback((context) => {
    return context.data.filter((step) => checkIfStepIsVisible(step, context));
  }, []);

  const [visibleSteps, setVisibleSteps] = useState([]);

  useEffect(() => {
    setVisibleSteps(getVisibleSteps(context))
  }, [selectedRoleType]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    countryApiRequest.get('/tintometers/colors/all')
      .then(setColors)
      .catch((err) => {

      })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  if (fetchFixedProducts === "error") {
    throw new Error("error on fetch products");
  }

  if (fetchFixedSystems === "error") {
    throw new Error("error on fetch systems");
  }

  if (!fetchFixedProducts) {
    return <FixedLoader />;
  }

  return (
    <>
      <div className="fixed z-0 top-0 left-0 w-full h-full z-10 bg-black opacity-50"></div>
      <div
        className="fixed z-10 top-0 left-0 bg-white w-full h-screen overflow-y-auto overflow-x-hidden"
      >
        <div className="container ml-auto pr-8 flex flex-col  max-w-md">
          <Select
            label="Select user type"
            options={roleTypes.map((r) => ({ name: r.name, value: r.name }))}
            value={selectedRoleType}
            onChange={(e) => {
              setSelectedRoleType(e.target.value);
              setResponses({});
            }}
          />
        </div>
        {data.length ? (
          <ConfiguratorContext.Provider value={context}>
            <ConfiguratorSurvey
              returnPath={returnPath}
              selectedRoleType={selectedRoleType}
              visibleSteps={visibleSteps}
              updateSteps={() => {
                const newResponses = convertSurveyResponses(
                  Object.values(responses),
                  context,
                  false
                );
                setResponses(newResponses);
                setVisibleSteps(getVisibleSteps({...context, responses: newResponses}))
              }}
            />
          </ConfiguratorContext.Provider>
        ) : null}
      </div>
    </>
  );
};

export default memo(ServiceConfiguratorPreview);
